function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3cd09f",
  d: "M15 0C6.7 0 0 6.7 0 15s6.7 15 15 15 15-6.7 15-15S23.3 0 15 0zm0 27C8.4 27 3 21.6 3 15S8.4 3 15 3s12 5.4 12 12-5.4 12-12 12z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M15 3V0C6.7 0 0 6.7 0 15h3C3 8.4 8.4 3 15 3z"
});

var SvgLoader = function SvgLoader(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 30 30"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMCAzMCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMzAgMzAiPgogIDxwYXRoIG9wYWNpdHk9IjEiIGZpbGw9IiMzY2QwOWYiIGQ9Ik0xNSAwQzYuNyAwIDAgNi43IDAgMTVzNi43IDE1IDE1IDE1IDE1LTYuNyAxNS0xNVMyMy4zIDAgMTUgMHptMCAyN0M4LjQgMjcgMyAyMS42IDMgMTVTOC40IDMgMTUgM3MxMiA1LjQgMTIgMTItNS40IDEyLTEyIDEyeiIgLz4KICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMTUgM1YwQzYuNyAwIDAgNi43IDAgMTVoM0MzIDguNCA4LjQgMyAxNSAzeiI+PC9wYXRoPgo8L3N2Zz4K";
export { SvgLoader as ReactComponent };